import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
function DropdownMenu({
  size = "medium",
  items,
  defaultCustomProject,
  selectOption,
  style = {},
}) {
  const [defaultItem, setDefaultItem] = useState({
    text: "",
    key: "",
    value: "",
  });

  useEffect(() => {
    const defaultItem = items.find(
      (i) => i.key === defaultCustomProject.value[0]
    );
    if (defaultItem) setDefaultItem(defaultItem);
    // eslint-disable-next-line
  }, [defaultCustomProject]);

  const handleChange = (_e, { value }) => {
    selectOption(value);
  };

  if (!Array.isArray(items) || items.length < 1) return null;

  return (
    <>
      <div
        className={`drop-down-nav ${size}`}
        data-testid="dropdown-menu"
        style={{ ...style }}
      >
        <Dropdown
          placeholder={defaultItem.text}
          defaultValue={defaultItem.key}
          onChange={handleChange}
          fluid
          search
          selection
          options={items}
        />
      </div>
    </>
  );
}

export default DropdownMenu;
